import { useState, useEffect, useRef } from 'react';

export const useThrottle = <T>(value: T, limit_ms: number) => {
  const [throttledValue, setThrottledValue] = useState(value);
  const lastRan = useRef(Date.now());

  useEffect(() => {
    const handler = setTimeout(
      function () {
        if (Date.now() - lastRan.current >= limit_ms) {
          setThrottledValue(value);
          lastRan.current = Date.now();
        }
      },
      limit_ms - (Date.now() - lastRan.current)
    );

    return () => {
      clearTimeout(handler);
    };
  }, [value, limit_ms]);

  return throttledValue;
};
